import { api } from './client'

// FR-31 Doc Library (CMS) API.

// ── Modules ──
export const listDocModules = (pid) =>
  api.get(`/cms/programs/${pid}/modules`).then((r) => r.data)
export const createDocModule = (pid, data) =>
  api.post(`/cms/programs/${pid}/modules`, data).then((r) => r.data)
export const seedDefaultModules = (pid) =>
  api.post(`/cms/programs/${pid}/modules/seed-defaults`).then((r) => r.data)
export const updateDocModule = (pid, id, data) =>
  api.put(`/cms/programs/${pid}/modules/${id}`, data).then((r) => r.data)
export const deleteDocModule = (pid, id) =>
  api.delete(`/cms/programs/${pid}/modules/${id}`).then((r) => r.data)

// ── Documents ──
export const listDocs = (pid, { status, module } = {}) => {
  const params = {}
  if (status) params.status = status
  if (module) params.module = module
  return api.get(`/cms/programs/${pid}/docs`, { params }).then((r) => r.data)
}
export const uploadDoc = (pid, { moduleId, name, file }) => {
  const fd = new FormData()
  fd.append('file', file)
  fd.append('moduleId', moduleId)
  if (name) fd.append('name', name)
  return api
    .post(`/cms/programs/${pid}/docs`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((r) => r.data)
}
export const updateDoc = (pid, id, data) =>
  api.put(`/cms/programs/${pid}/docs/${id}`, data).then((r) => r.data)
export const approveDoc = (pid, id) =>
  api.post(`/cms/programs/${pid}/docs/${id}/approve`).then((r) => r.data)
export const rejectDoc = (pid, id, reason) =>
  api.post(`/cms/programs/${pid}/docs/${id}/reject`, { reason }).then((r) => r.data)
export const uploadDocVersion = (pid, id, file) => {
  const fd = new FormData()
  fd.append('file', file)
  return api
    .post(`/cms/programs/${pid}/docs/${id}/versions`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((r) => r.data)
}
export const getDocDownloadUrl = (pid, id) =>
  api.get(`/cms/programs/${pid}/docs/${id}/download`).then((r) => r.data)
